const APP_PROVIDER_PREFIXES = [
  '/book',
  '/booking',
  '/dashboard',
  '/admin',
  '/auth',
  '/provider',
] as const;

/** Routes that must hydrate Auth + React Query on first paint. */
export function pathNeedsAppProviders(pathname: string): boolean {
  const path = pathname.split('?')[0] || '/';
  return APP_PROVIDER_PREFIXES.some(prefix => path === prefix || path.startsWith(`${prefix}/`));
}
